<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
        <v-skeleton-loader type="heading"></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-skeleton-loader max-width="300" type="card"></v-skeleton-loader>
        <v-skeleton-loader max-width="300" type="card"></v-skeleton-loader>
        <v-skeleton-loader max-width="300" type="card"></v-skeleton-loader>
      </v-col>
      <v-col cols="8" align="center" class="justify-center">
        <p class="mt-10">
          {{$i18n.t('LoadingPage.text')}}<br/>
          <spinner/>
        </p>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { mapState } from 'vuex';
import LoadingState from '@/api/LoadingState';
import Spinner from './Spinner';

export default {
  // eslint-disable vue/multi-word-component-names
  name: 'Loader',
  components: {
    Spinner,
  },
  data: () => ({
  }),
  computed: {
    ...mapState({
      runInfo: (state) => state.run.runInfo,
      runState: (state) => state.run.runState,
      loading: (state) => state.run.loadingState.runInfo === LoadingState.LOADING,
      loaded: (state) => state.run.loadingState.runInfo === LoadingState.LOADED
    }),
  },
  watch: {
    // runInfoLoaded() {
    //   this.checkRunStateAndRedirect();
    // }
  },
  methods: {
    checkRunStateAndRedirect() {
      if (this.runState < 2 || this.runState > 5) {
        this.$router.push('blocker')
      } else {
        this.$router.push('overview')
      }
    }
  },
  mounted() {
    // done: Propably wait for all contents using promises
    // Initialize the webapp with the runInformation and display this loader until the first runinformation is fetched
    const self = this;
    if (!this.loading && !this.loaded) {
      self.$api.run.get('candidate');
      setTimeout(() => self.checkRunStateAndRedirect(), 500)
    } else {
      this.checkRunStateAndRedirect()
    }
    // do we have to init the status updater here too or is it already initialized on app entry
  },
};
</script>
